<nb-accordion class="mb-4">
  <nb-accordion-item [expanded]="true">
    <nb-accordion-item-header>
      <div class="d-flex align-items-center">
        <i class="far fa-chart-line ms-2"></i>
        <span>گزارش‌گیری</span>
      </div>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div class="row mb-3">
        <div class="col-12 col-lg-12">
          <nb-card>
            <nb-card-header>فقط کاربران لیست</nb-card-header>
            <nb-card-body>
              <app-user-picker
                (add)="includedUsers = $event"
                (remove)="includedUsers = $event"
                [cacheKey]="'transaction_included_users'"
              ></app-user-picker>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3">
        <div class="d-flex" style="width: 200px">
          <nb-select fullWidth [(selected)]="status" placeholder="همه تراکنش‌ها">
            <nb-option [value]="undefined">همه تراکنش‌ها</nb-option>
            <nb-option [value]="WithdrawRialStatus.SUCCESSFUL">موفق</nb-option>
            <nb-option [value]="WithdrawRialStatus.FAILED">ناموفق</nb-option>
            <nb-option [value]="WithdrawRialStatus.PENDING">در حال بررسی</nb-option>
          </nb-select>
        </div>
        <button nbButton status="primary" (click)="getDepositList({ first: 0, rows: limit })">
          گزارش‌گیری
        </button>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
<nb-card>
  <nb-card-header>لیست برداشت‌های ریالی</nb-card-header>
  <nb-card-body>
    <div class="d-none d-lg-flex align-items-center mb-2">
      <nb-select
        class="ms-2"
        [selected]="15"
        (selectedChange)="changeRecordPerPageLimit($event)"
        placeholder="تعداد رکورد"
      >
        <nb-option [value]="10">10</nb-option>
        <nb-option [value]="15">15</nb-option>
        <nb-option [value]="25">25</nb-option>
        <nb-option [value]="50">50</nb-option>
        <nb-option [value]="100">100</nb-option>
      </nb-select>
    </div>
    <p-table
      [value]="pagination.data"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [lazy]="true"
      (onLazyLoad)="getDepositList($event)"
      [alwaysShowPaginator]="false"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="limit"
      [totalRecords]="pagination.totalRecords"
      [loading]="loading"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>شناسه</th>
          <th>کاربر</th>
          <th>نام بانک</th>
          <th>شماره شبا</th>
          <th>مقدار</th>
          <th>کارمزد</th>
          <th>وضعیت بانکی</th>
          <th>درگاه بانکی</th>
          <th>وضعیت</th>
          <th>شناسه بانک</th>
          <th>تاریخ ایجاد</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-withdraw>
        <tr>
          <td>{{ withdraw.id }}</td>
          <td>
            <a
              class="text-primary"
              [routerLink]="withdraw.user?.id ? '/dashboard/user/' + withdraw.user?.id : null"
            >
              {{
              withdraw.user?.firstName || withdraw.user?.lastName
                ? withdraw.user.firstName + ' ' + withdraw.user.lastName
                : '-'
              }}
            </a>
          </td>
          <td>{{ withdraw.userIban | bankName : 'IBAN' | translateBankName }}</td>
          <td class="code">
            <i
              (click)="copy(withdraw.userIban, 'شماره شبا کپی شد.')"
              class="far fa-copy ms-1 cursor-pointer text-primary"
            ></i>
            {{ withdraw.userIban }}
          </td>
          <td>
            {{ withdraw.amount | number : '1.0-8' }}
          </td>
          <td>
            {{ withdraw.fee | number : '1.0-8' }}
          </td>
          <td *ngIf="withdraw.jibitStatus; else empty">
            <span
              [ngClass]="{
                'text-danger':
                  withdraw.jibitStatus === 'FAILED' || withdraw.jibitStatus === 'CANCELLED',
                'text-success': withdraw.jibitStatus === 'TRANSFERRED',
                'text-warning':
                  withdraw.jibitStatus === 'TRANSFERRED_PARTIAL' ||
                  withdraw.jibitStatus === 'IN_PROGRESS'
              }"
            >
              {{ withdraw.jibitStatusText }}
            </span>
          </td>
          <td>{{withdraw.provider}}</td>
          <td>
            <span
              [class.text-success]="withdraw.status === WithdrawRialStatus.SUCCESSFUL"
              [class.text-warning]="withdraw.status === WithdrawRialStatus.PENDING"
              [class.text-danger]="
                withdraw.status === WithdrawRialStatus.FAILED ||
                withdraw.status === WithdrawRialStatus.ERROR
              "
            >
              {{ withdraw.status | withdrawStatus }}
            </span>
          </td>
          <td *ngIf="withdraw.bankTransferId; else empty" class="code">
            {{ withdraw.bankTransferId }}
          </td>
          <ng-template #empty>
            <td>-</td>
          </ng-template>
          <td>
            {{ withdraw.createdAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </nb-card-body>
</nb-card>
